export default class SelectIsaModalController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any[]} descendants
	 */
	constructor(
		$uibModalInstance,
		descendants,
	) {
		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.isa = undefined;
		this.$uibModalInstance = $uibModalInstance;
		this.descendants = descendants.map(descendant => ({ ...descendant, active: false }));
		this.active = undefined;
		/** @type {?import('angular').IFormController} */
		this.form = null;
	}

	cancel() {
		return this.$uibModalInstance.dismiss('cancel');
	}

	submit() {
		return this.$uibModalInstance.close(this.descendants.length === 0 ? this.isa : this.active?.kid);
	}

	/**
	 * @param {any} descendant
	 */
	toggleActive(descendant) {
		if (this.active && descendant.kid !== this.active.kid) {
			this.active.active = false;
		}
		descendant.active = !descendant.active;
		this.active = descendant.active ? descendant : undefined;
		if (this.form) {
			this.form.$setValidity('required', this.active !== undefined, this.form);
		}
	}
}
